import React, {PureComponent} from "react";
import {FormattedMessage} from "react-intl";

interface Props {
    closeAlert: () => void;
    game: string;
}

export default class MobileLaunchModal extends PureComponent<Props> {
    componentDidMount(): void {
        document.body.classList.add('overflow-hidden');
    }

    componentWillUnmount(): void {
        document.body.classList.remove('overflow-hidden');
    }

    render(): JSX.Element {
        return (
            <div className="alertOverlay" onClick={this.props.closeAlert}>
                <div className="alertOuter" onClick={e => e.stopPropagation()}>
                    <div className="alertInner">
                        <div className="alertHeader">
                            <button type="button" className="alertClose" aria-label="Close this dialog" onClick={this.props.closeAlert}>
                                ×
                            </button>
                        </div>
                        <div className="alertBox">
                            <div className="alertContent">
                                <div className="alertText mt-0">
                                    <FormattedMessage
                                        id="warning.mobile_launch_alert.body"
                                        values={{ game: <b>{this.props.game}</b> }}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="alertFooter text-center">
                            <button type="button" className="alertConfirm float-none" aria-label="Confirm" onClick={this.props.closeAlert}>
                                <FormattedMessage id="rewards.close"/>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}